export const ROUTES = {
  LANDING: 'landing',
  INTERVIEW: 'interview',
  INTERVIEW_AI: 'interview-ai',
  INTERVIEW_PRE_BUILT: 'interview-pre-built',
  INTERVIEW_CUSTOM: 'custom-interview',
  INTERVIEWS_LIST: 'interviews-list',
  FEEDBACK_PAGE: 'feedback',
  MOCK_INTERVIEWS: 'mock-interviews',
  MOCK_INTERVIEW_TEST: 'mock-interview-test',
  MOCK_INTERVIEW_START: 'mock-interview',
  MOCK_INTERVIEW_RECORD: 'mock-interview-question',
  MOCK_INTERVIEW_END: 'mock-interview-result',
  QUESTIONS: 'questions',
  QUESTIONS_CUSTOM_INTERVIEW: 'questions-custom-interview',
  FEEDBACK: 'feedback',
  REVIEW_GRID: 'review-grid',
  SHARE_INTERVIEW: 'share-interview',
  RECRUITER: 'recruiter',
  INTERVIEW_RECRUITER: 'interview-recruiter',
};

export const MENU_ARRAY = [
  {
    name: 'Home',
    link: `/${ROUTES.LANDING}`,
  },
  {
    name: 'Mock Interviews',
    link: `/${ROUTES.MOCK_INTERVIEWS}`,
  },
  {
    name: 'Browse Questions',
    link: `/${ROUTES.QUESTIONS}`,
  },
  {
    name: 'My Interviews',
    link: `/${ROUTES.INTERVIEWS_LIST}`,
    }
];

export const CASE = {
    UPPER_CASE: 'upperCase',
    LOWER_CASE: 'lowerCase'
};

export const ANALYSIS_TYPES = {
  PERCEIVED_EMOTION: 'perceivedEmotion',
  EYE_MOVEMENT: 'eyeMovement',
  SMILE_FREQUENCY: 'smileFrequency',
  SPEECH_RATE: 'speechRate',
  SPEECH_CLARITY: 'speechClarity',
  FILLER_WORDS: 'fillerWords',
  CENTRAL_POSITION: 'centralPosition',
  EYELINE: 'eyeline',
  CAMERA_DISTANCE: 'cameraDistance',
  SHARPNESS: 'sharpness',
  BRIGHTNESS: 'brightness',
  OVERALL_QUALITY: 'overallQuality',
};

export const INTERVIEWS_PER_PAGE = 12;
export const QUESTIONS_PER_PAGE = 10;
export const CV_TRESHOLD = 60;
export const ELEARNING_ASSETS_PER_PAGE = 12;
export const ELEARNING_ASSETS_PER_PAGE_MOBILE = 8;
export const REVIEW_GRID_PER_PAGE = 25;

export const API_PATH = '/api/Interview360';
export const API_PATH_REVIEW = '/api/Interview360Review';
export const API_PATH_SHARE_INTERVIEW = '/apiext/Interview360ReviewExternal';
export const API_PATH_RECRUITER = '/api/Int360Recruiter';

export const INTERVIEW_TYPES = {
  AI: 'AI CV Interview',
  AUTO_GENERATED: 'Auto-Generated Interview',
  CUSTOM: 'Custom Interview',
  RECRUITER: 'SALES MANAGER INTERVIEW',
};

export const EMOTION_WORDS = {
  GOOD: ['happy', 'enthusiastic', 'surprised', 'calm', 'empathetic'],
  NORMAL: ['serious', 'confused'],
  BAD: ['sad', 'angry', 'bored', 'disgusted', 'anxious', 'fear', 'frustrated'],
};

export const EMOTION_WORDS_REPLACEMENT = {
  happy: 'Uplifter',
  enthusiastic: 'Momentum Builder',
  surprised: 'Momentum Builder',
  calm: 'Calming Presence',
  serious: 'Straight Shooter',
  confused: 'Straight Shooter',
  empathetic: 'Connector',
  angry: 'Need More Positivity',
  frustrated: 'Need More Positivity',
  bored: 'A Spark is Needed',
  disgusted: 'A Spark is Needed',
  anxious: 'Take a Breath',
  fear: 'Take a Breath',
};

export const INTERVIEW_HUB_PATH = '/interview360hub';

export const INTERVIEW_RECORDING_TYPES = {
  VIDEO: 1,
  TEXT: 2,
};

export const INTERVIEW_BUILD_TYPES = {
  CUSTOM: 0,
  AI: 1,
  PREBUILD: 2,
};

export const SESSION_TIME = 10800000; //milliseconds

export const CONFIDENCE_RATING = {
  'below average': [0, 5],
  average: [6, 8],
  'above average': [9, 10],
};

export const ERRORS = {
  LOGGED_NOT_TAKEN_INTERVIEW:
    'Logged in user did not take this mock interview before',
};

export const VIDEO_SETTINGS = {
  BRIGHTCOVE_ACCOUNT_ID: '70829881001',
  BRIGHTCOVE_PLAYER_ID: 'jT8dA3CsT',
};

export const VIEW_STATUS_COLOR = ['black', 'red', 'green'];

export const USER_ROLES = {
  ADMIN: 'Admin',
  COACH: 'Coach',
  FIRM_ADMIN: 'Firm Admin',
  BUSINESS_DEVELOPMENT: 'Business Development',
  EMPLOYER: 'Employer',
};

export const USER_ROLES_MAP_ID = {
  1: USER_ROLES.ADMIN,
  2: USER_ROLES.COACH,
  3: USER_ROLES.FIRM_ADMIN,
  4: USER_ROLES.BUSINESS_DEVELOPMENT,
  5: USER_ROLES.EMPLOYER,
};

export const CCM_REVIEW_STATUS = {
  REVIEWED: 'Reviewed',
  UNDER_REVIEW: 'UnderReview',
  PENDING: 'Pending',
};

export const REVIEW_MAX_SYMBOLS = 10000;
export const REVIEW_MIN_SYMBOLS = 2;

export const ERROR_MESSAGES = {
  COMMON: 'Sorry, there was a problem. Please try again later.',
};

export const EXTERNAL_ACCESS_TYPE = {
  READONLY: 1,
  EXTERNAL_REVIEWER: 2,
  CCM_READONLY: 3,
};
